/**
 * Isabel Lavigne – Custom Cart Drawer
 * Replicates mabelmaemargot.com slide-out cart with quantity discount progress bar.
 * Tiers: 2 items = 10% (BUY2SAVE10%), 3 items = 15% (BUY3SAVE15%), 4+ items = 25% (BUY4SAVE25%)
 */
(function () {
  'use strict';

  /* ── Discount tiers ───────────────────────────────── */
  const TIERS = [
    { min: 2, pct: 10, badge: 'BUY2SAVE10%' },
    { min: 3, pct: 15, badge: 'BUY3SAVE15%' },
    { min: 4, pct: 25, badge: 'BUY4SAVE25%' },
  ];

  /* ── Money helper ───────────────────────────────── */
  function fmt(cents) {
    const fmt = window.ilMoneyFormat || '{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  /* ── Tier helper ────────────────────────────────── */
  function getTier(n) {
    return TIERS.slice().reverse().find(t => n >= t.min) || null;
  }

  /* ── State ────────────────────────────────────── */
  let isOpen = false;
  let _updating = false;

  /* ── DOM refs (lazy) ───────────────────────────── */
  const $ = id => document.getElementById(id);

  /* ── Open ─────────────────────────────────────── */
  async function open() {
    if (isOpen) return;
    isOpen = true;
    await fetchAndRender();
    $('il-cart-overlay').classList.add('il-visible');
    $('il-cart-drawer').classList.add('il-open');
    document.body.classList.add('il-cart-open');
  }

  /* ── Close ────────────────────────────────────── */
  function close() {
    isOpen = false;
    const o = $('il-cart-overlay'), d = $('il-cart-drawer');
    if (o) o.classList.remove('il-visible');
    if (d) d.classList.remove('il-open');
    document.body.classList.remove('il-cart-open');
  }

  window.ilCartOpen  = open;
  window.ilCartClose = close;

  /* ── Fetch & render ────────────────────────────── */
  async function fetchAndRender() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    render(cart);
    return cart;
  }

  function render(cart) {
    updateCount(cart.item_count);
    updateProgress(cart.item_count);
    renderItems(cart);
    renderFooter(cart);
  }

  /* ── Header count ───────────────────────────────── */
  function updateCount(n) {
    const el = $('il-cart-count');
    if (el) el.textContent = n;
    document.querySelectorAll('.cart-bubble__text-count').forEach(b => {
      b.textContent = n > 0 ? n : '';
    });
  }

  /* ── Progress bar ───────────────────────────────── */
  const MS_POS = [28, 58, 88];

  function updateProgress(n) {
    const fill    = $('il-progress-fill');
    const msg     = $('il-progress-msg');
    const applied = $('il-discount-applied-msg');

    let pct = 0;
    if (n >= 4)      pct = MS_POS[2];
    else if (n >= 3) pct = MS_POS[1];
    else if (n >= 2) pct = MS_POS[0];
    if (fill) fill.style.width = pct + '%';

    [1, 2, 3].forEach(i => {
      const c = $('il-ms-circle-' + i);
      if (c) c.classList.toggle('il-reached', n >= TIERS[i - 1].min);
    });

    const tier = getTier(n);
    if (!msg || !applied) return;

    if (!tier) {
      const need = 2 - n;
      msg.innerHTML = need <= 1
        ? 'Add <strong>1 more item</strong> and receive <strong>10% off</strong>'
        : 'Add <strong>2 items</strong> and receive <strong>10% off</strong>';
      applied.textContent = '';
    } else {
      const next = TIERS.find(t => t.min > n);
      if (next) {
        const need = next.min - n;
        msg.innerHTML = 'Add ' + need + ' more item' + (need > 1 ? 's' : '') + ' and receive <strong>' + next.pct + '% off</strong>';
      } else {
        msg.innerHTML = '<strong>' + tier.pct + '% off</strong> is now applied to your order!';
      }
      applied.textContent = tier.pct + '% off applied!';
    }
  }

  /* ── Cart items ────────────────────────────────── */
  function renderItems(cart) {
    const wrap = $('il-items-scroll');
    if (!wrap) return;

    if (!cart.items || cart.items.length === 0) {
      wrap.innerHTML = '<div class="il-empty-state">Your cart is empty</div>';
      return;
    }

    const tier    = getTier(cart.item_count);
    const discPct = tier ? tier.pct / 100 : 0;

    wrap.innerHTML = cart.items.map(function(item) {
      const origUnit = item.original_price;
      const origLine = origUnit * item.quantity;
      const discLine = Math.round(origLine * (1 - discPct));

      let imgSrc = '';
      if (item.featured_image && item.featured_image.url) {
        imgSrc = item.featured_image.url;
      } else if (item.image) {
        imgSrc = item.image;
      }
      if (imgSrc) {
        imgSrc = imgSrc.replace(/(\.[^.?]+)(\?|$)/, '_100x100$1$2');
      }

      const imgHtml = imgSrc
        ? '<img class="il-item-img" src="' + imgSrc + '" alt="' + esc(item.product_title) + '" loading="lazy">'
        : '<div class="il-item-img il-no-img"></div>';

      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="il-item-variant">' + esc(item.variant_title) + '</p>'
        : '';

      const priceHtml = tier
        ? '<span class="il-item-orig">' + fmt(origLine) + '</span><span class="il-item-disc">' + fmt(discLine) + '</span>'
        : '<span class="il-item-disc">' + fmt(origLine) + '</span>';

      const key = esc(item.key);
      return '<div class="il-item">' +
        imgHtml +
        '<div class="il-item-info">' +
          '<p class="il-item-title">' + esc(item.product_title) + '</p>' +
          variantHtml +
          '<div class="il-item-row">' +
            '<div class="il-qty-wrap">' +
              '<button class="il-qty-btn" onclick="ilQtyChange(\'' + key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease quantity">−</button>' +
              '<span class="il-qty-num">' + item.quantity + '</span>' +
              '<button class="il-qty-btn" onclick="ilQtyChange(\'' + key + '\',' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="il-price-wrap">' + priceHtml + '</div>' +
          '</div>' +
        '</div>' +
        '<button class="il-remove-btn" onclick="ilQtyChange(\'' + key + '\',0)" aria-label="Remove item">×</button>' +
        '</div>';
    }).join('');
  }

  /* ── Footer totals ──────────────────────────────── */
  function renderFooter(cart) {
    const discRow  = $('il-discount-row');
    const badge    = $('il-discount-badge');
    const savings  = $('il-discount-savings');
    const subtotal = $('il-subtotal-val');
    if (!discRow || !subtotal) return;

    const tier = getTier(cart.item_count);
    let origTotal = (cart.items || []).reduce(function(s, i) { return s + i.original_price * i.quantity; }, 0);

    if (tier && origTotal > 0) {
      const disc  = Math.round(origTotal * tier.pct / 100);
      const final = origTotal - disc;
      discRow.style.display = 'flex';
      if (badge)   badge.textContent   = tier.badge;
      if (savings) savings.textContent = '-' + fmt(disc);
      subtotal.textContent = fmt(final);
    } else {
      discRow.style.display = 'none';
      subtotal.textContent  = fmt(origTotal);
    }
  }

  /* ── Qty change ────────────────────────────────── */
  window.ilQtyChange = async function (key, qty) {
    if (_updating) return;
    _updating = true;
    const wrap = $('il-items-scroll');
    if (wrap) { wrap.style.opacity = '0.5'; wrap.style.pointerEvents = 'none'; }
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
      });
      const cart = await res.json();
      render(cart);
    } finally {
      _updating = false;
      if (wrap) { wrap.style.opacity = ''; wrap.style.pointerEvents = ''; }
    }
  };

  /* ── HTML escape ───────────────────────────────── */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Intercept fetch → auto-open on add-to-cart ──────────── */
  const _origFetch = window.fetch;
  window.fetch = function () {
    const args = Array.prototype.slice.call(arguments);
    const url    = (typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url)) || '';
    const promise = _origFetch.apply(window, args);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      promise.then(function(r) {
        if (r.ok) r.clone().json().then(function() { isOpen ? fetchAndRender() : open(); }).catch(function() {});
      }).catch(function() {});
    }
    return promise;
  };

  /* ── Listen for theme cart events ───────────────────── */
  ['cart:item-added', 'cart:refresh', 'cart-lines:update'].forEach(function(ev) {
    document.addEventListener(ev, function() { if (isOpen) fetchAndRender(); });
  });

  /* ── Escape key ───────────────────────────────── */
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && isOpen) close(); });

  /* ── Init ─────────────────────────────────────── */
  function init() {
    var triggers = document.querySelectorAll(
      '[data-testid="cart-drawer-trigger"], [on\\:click*="cart-drawer"], a[href="/cart"]'
    );
    triggers.forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        open();
      }, true);
    });

    var overlay = document.getElementById('il-cart-overlay');
    if (overlay) overlay.addEventListener('click', close);

    _origFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCount(cart.item_count); })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
